// Runtime library: the manifest, the books, and the review word table.
//
// These used to be sixteen static imports in src/data/texts.js — 3.5 MB of story
// JSON compiled into the bundle (~249 kB of the 345 kB served gzipped) and parsed
// before the library list could paint, for a reader who opens one book. They now
// come from R2 on demand: an 11.7 kB manifest at startup, then ~16 kB gzipped for
// whichever book is actually opened. See scripts/gen_library.mjs for the bake.
//
// Same promise-caching shape as src/dict.js: the PROMISE is cached rather than the
// result, so two things asking at once share one download, and a rejected load is
// dropped so a flaky connection cannot wedge a book shut for the session.
import { LIBRARY_BASE } from './api';

async function getJson(path, init) {
  const r = await fetch(`${LIBRARY_BASE}/${path}`, init);
  if (!r.ok) throw new Error(`library/${path}: HTTP ${r.status}`);
  return r.json();
}

let manifestP = null;

// The one mutable file in the whole bucket. Everything it points at is immutable
// under `?v=<digest>`, so this is what has to be re-checked: it is served
// must-revalidate, and a book that changed shows up as a moved digest here. Hence
// no cache-buster on this URL — a stamp would defeat the revalidation it needs.
export function loadLibrary() {
  if (!manifestP) {
    manifestP = getJson('index.json');
    manifestP.catch(() => { manifestP = null; });
  }
  return manifestP;
}

const storyP = new Map();

// Takes the manifest ROW, not a code: the row carries the digest, and the digest
// is the only thing that makes the immutable cache safe to trust.
export function loadStory(row) {
  let p = storyP.get(row.code);
  if (!p) {
    p = getJson(`${row.file}?v=${row.digest}`);
    p.catch(() => storyP.delete(row.code));
    storyP.set(row.code, p);
  }
  return p;
}

let wordDialectsP = null;

// word -> [dialect]. Only the 複習 screen needs it, so it is not fetched until a
// review session opens. Keyed at bake time with the app's own cleanWord, which is
// what the lookup below has to match.
export function loadWordDialects(manifest) {
  if (!wordDialectsP) {
    const { file, digest } = manifest.wordDialects;
    wordDialectsP = getJson(`${file}?v=${digest}`);
    wordDialectsP.catch(() => { wordDialectsP = null; });
  }
  return wordDialectsP;
}

export const storiesIn = (manifest, dialect) =>
  manifest.stories.filter((s) => s.dialect === dialect);

// Load every book in a dialect (one, today) and hand back the full story objects.
export const loadStoriesIn = (manifest, dialect) =>
  Promise.all(storiesIn(manifest, dialect).map(loadStory));
